import { Dialog, DialogContent } from "@/components/ui/dialog";

export interface MediaPreviewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  url: string;
}

export const MediaPreviewDialog = ({ open, onOpenChange, url }: MediaPreviewDialogProps) => {
  const isVideo = url.match(/\.(mp4|webm|ogg)$/i);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        {isVideo ? (
          <video src={url} controls className="w-full h-auto" />
        ) : (
          <img src={url} alt="Preuve de perte" className="w-full h-auto" />
        )}
      </DialogContent>
    </Dialog>
  );
};